import { FC } from "react";
import { Link, useLocation } from "react-router-dom";
import { Layout, Menu, Image, Typography } from "antd";
import {
  ProductOutlined,
  PictureOutlined,
  IdcardOutlined,
  HomeOutlined,
  InboxOutlined,
  ShoppingCartOutlined,
  ShopOutlined,
  FundOutlined,
  EnvironmentOutlined,
  TagOutlined,
  UserOutlined,
  BellOutlined,
  BookOutlined,
  ContainerOutlined,
} from "@ant-design/icons";
import { useUser } from "../../providers/user";

const { Sider } = Layout;
const { Item, SubMenu } = Menu;
const { Text } = Typography;

interface SidebarProps {
  collapsed: boolean;
  onCollapse: (collapsed: boolean) => void;
}

const menuItems = [
  {
    key: "/dashboard",
    label: "Dashboard",
    route: "/dashboard",
    icon: <HomeOutlined />,
    allowedRoles: ["admin"],
  },
  {
    key: "orders",
    label: "Órdenes",
    subMenu: [
      {
        key: "/orders",
        label: "Activas",
        route: "/orders",
        icon: <HomeOutlined />,
      },
      {
        key: "/history",
        label: "Pagadas",
        route: "/history",
        icon: <FundOutlined twoToneColor="#fff" />,
      },
      {
        key: "/abandoned-checkout",
        label: "Abandonado",
        route: "/abandoned-checkout",
        icon: <FundOutlined twoToneColor="#fff" />,
      },
    ],
    icon: <ShoppingCartOutlined />,
    allowedRoles: ["admin", "manager", "support"],
  },
  {
    key: "catalog",
    label: "Catalogo",
    subMenu: [
      {
        key: "/products",
        label: "Productos",
        route: "/products",
        icon: <InboxOutlined />,
      },
      {
        key: "/categories",
        label: "Categorias",
        route: "/categories",
        icon: <ProductOutlined />,
      },
      {
        key: "/banners",
        label: "Banners",
        route: "/banners",
        icon: <PictureOutlined />,
      },
      {
        key: "/coupons",
        label: "Cupones",
        route: "/coupons",
        icon: <TagOutlined twoToneColor="#fff" />,
      },
      {
        key: "/franchise",
        label: "Franquicias",
        route: "/franchise",
        icon: <ShopOutlined />,
      },
      {
        key: "/notifications",
        label: "Notificaciones",
        route: "/notifications",
        icon: <BellOutlined />,
      },
    ],
    icon: <ProductOutlined />,
    allowedRoles: ["admin"],
  },
  {
    key: "users",
    label: "Usuarios",
    subMenu: [
      {
        key: "/users",
        label: "Usuarios",
        route: "/users",
        icon: <IdcardOutlined />,
      },

      {
        key: "/clients",
        label: "Clientes",
        route: "/clients",
        icon: <UserOutlined />,
      },
      {
        key: "/zones",
        label: "Zonas",
        route: "/zones",
        icon: <EnvironmentOutlined />,
      },
    ],
    icon: <UserOutlined />,
    allowedRoles: ["admin"],
  },
  {
    key: "/tickets",
    label: "Tickets",
    route: "/tickets",
    icon: <BookOutlined />,
    allowedRoles: ["admin", "support"],
  },
  {
    key: "/invoices",
    label: "Facturas",
    route: "/invoices",
    icon: <ContainerOutlined />,
    allowedRoles: ["admin", "manager"],
  },
];

const Sidebar: FC<SidebarProps> = ({ collapsed, onCollapse }) => {
  const { user } = useUser();
  const location = useLocation();
  const selectedKey = location.pathname.toLowerCase();

  const userRole = user?.type ?? "";

  const filteredMenuItems = menuItems.filter((item) =>
    item.allowedRoles.includes(userRole));

  return (
    <Sider collapsible collapsed={collapsed} onCollapse={onCollapse}>
      <div style={{ textAlign: "center",
        padding: "16px" }}>
        <Image
          height={85}
          preview={false}
          src="/logo-pollo-loco.png"
          alt="Logo"
        />
      </div>
      <Menu
        theme="dark"
        mode="inline"
        defaultSelectedKeys={[selectedKey]}
        selectedKeys={[selectedKey]}
      >
        {filteredMenuItems.map(({ key, label, route, icon, subMenu }) => {
          return subMenu ? (
            <SubMenu
              icon={icon}
              title={
                <Text strong style={{ color: "white" }}>
                  {label}
                </Text>
              }
            >
              {subMenu?.map(({ key, label, route, icon }) => {
                return (
                  <Item key={key} icon={icon}>
                    <Link to={route}>
                      <Text style={{ color: "#fff" }}>{label}</Text>
                    </Link>
                  </Item>
                );
              })}
            </SubMenu>
          ) : (
            <Item key={key} icon={icon}>
              <Link to={route}>
                <Text style={{ color: "#fff" }}>{label}</Text>
              </Link>
            </Item>
          );
        })}
      </Menu>
    </Sider>
  );
};

export default Sidebar;
